module.exports = __webpack_public_path__ + "static/media/CTLI_14-293w.e7088c40.webp";